const components = {
  HeaderSetting: {
    changethepassword: "修改密码",
    logout: "退出登录",
    enter1: "请输入旧密码",
    enter2: "请输入新密码",
    enter3: "请再次输入新密码",
    confirm: "确定",
    cancel: "取消",
    error1: "请输入旧密码",
    error2: "请输入新密码",
    error3: "密码长度最少为6位",
    error4: "两次输入密码不一致",
    error5: "请再次输入新密码",
    message1: "修改密码成功",
    message2: "修改密码失败",
    inputlabelwidth: "120px"
  }
} 
export default components